import { isEmpty } from 'lodash';
import { useEffect, useState } from 'react';
import { FaYoutube } from 'react-icons/fa';
import { FiArrowRightCircle } from 'react-icons/fi';
import { RiPlayList2Fill } from 'react-icons/ri';
import { API_URI } from 'src/constants';
import { GET } from 'src/services';
import { sendDataLayerGlobal } from 'src/utils/datalayer/send-datalayer';
import styled from 'styled-components';

const SectionYoutube = ({ sectionYoutube, eventDataLayer }) => {
  const [sectionData, setSectionData] = useState(null);
  const [specialData, setSpecialData] = useState(null);
  useEffect(() => {
    const fetchAPI = async (keys) => {
      try {
        const listsId = keys;
        // const limit = 200;
        // const uri = `https://youtube.googleapis.com/youtube/v3/playlists?part=snippet%2CcontentDetails&channelId=${NEXT_PUBLIC_CHANEL_ID}&maxResults=${limit}&key=${NEXT_PUBLIC_API_YOUTUBE}`;
        const uri = `${API_URI}/api/youtube/playlists?part=snippet%2CcontentDetails&id=${listsId}`;
        // const uri = `${API_URI}/api/youtube/playlists?part=snippet%2CcontentDetails&channelId=${NEXT_PUBLIC_CHANEL_ID}`;
        const res = await GET(uri, true, false);
        // console.log(uri, res);

        // const listSpecial = ['กรุงเทพธุรกิจNEWS'];
        // const listChanel = ['Deep Talk', 'Money Club', 'The Unlock', 'The Thought leaders', 'กรุงเทพธุรกิจBrief'];
        // const listChanel = ['กรุงเทพธุรกิจ INSIGHT', 'UOB Asean Connect'];
        // const data = res?.items
        //   .filter((el) => listChanel.map((ch) => ch.toLowerCase()).includes(el.snippet.title.toLowerCase()))
        //   .sort((a, b) => listChanel.map((ch) => ch.toLowerCase()).indexOf(a.snippet.title.toLowerCase()) - listChanel.map((ch) => ch.toLowerCase()).indexOf(b.snippet.title.toLowerCase()));
        const data = res?.items?.slice(1);
        // console.log(res?.items);
        // const dataSpecial = res?.items.find((el) => listSpecial.map((el) => el.toLowerCase()).includes(el.snippet.title.toLowerCase()));
        const dataSpecial = res?.items[0];
        setSectionData(data);
        setSpecialData(dataSpecial);
      } catch (error) {
        console.error('fetchAPI -> error', error);
      }
    };

    const keys = sectionYoutube?.dataSet.map(key => key?.value);
    // console.log({ sectionYoutube, keys });

    fetchAPI(keys);
  }, []);
  // console.log({ sectionData, specialData });
  if (!sectionData || !specialData) return null;
  return (
    <SectionWrapper>
      <div className='block-wrapper'>
        <div className='block-title --video'>
          <h2> <FaYoutube className='counter-icon' style={{ color: '#fff' }} /> {'กรุงเทพธุรกิจ Youtube'}</h2>
          <a href='https://www.youtube.com/@bangkokbiznewsthailand' className='more' target='_blank' rel={'noopener noreferrer'}
            onClick={() => sendDataLayerGlobal({
              ...eventDataLayer,
              data: {
                ...eventDataLayer?.data,
                heading: 'Youtube',
                title: 'ดูทั้งหมด'
              }
            })}
          >
            ดูทั้งหมด <FiArrowRightCircle />
          </a>
        </div>
      </div>
      <div className='grid-block'>
        <div className='block-1'>
          {specialData && <a href={`https://www.youtube.com/playlist?list=${specialData?.id}`} target='_blank' rel={'noopener noreferrer'}
           onClick={() => sendDataLayerGlobal({
             ...eventDataLayer,
             data: {
               ...eventDataLayer?.data,
               heading: 'Youtube',
               title: specialData?.snippet?.title,
               index: 1,
               block: '1'
             }
           })} >
            <div className='card-image'>
              <div className='icon-play'>
                <FaYoutube size={80} />
              </div>
              <img src={specialData?.snippet?.thumbnails?.maxres?.url} alt={specialData?.snippet?.title} width={640} height={480} />
              <small className='count'> <RiPlayList2Fill size={16} /> {`${specialData?.contentDetails.itemCount} วิดีโอ`}</small>
            </div>
            <h3 className='title'>{specialData.snippet.title}</h3>
          </a>}
        </div>
        <div className='block-2'>
          <ul className='video-playlists playlist-custom-scroll --vertical'>
            {
              !isEmpty(sectionData) && sectionData.map((item, index) => (
                <li key={index} className='grid-item'
                  onClick={() => sendDataLayerGlobal({
                    ...eventDataLayer,
                    data: {
                      ...eventDataLayer?.data,
                      heading: 'Youtube',
                      title: item.snippet.title,
                      index: index + 1,
                      block: '2'
                    }
                  })}
                >

                  <a href={`https://www.youtube.com/playlist?list=${item?.id}`} target='_blank' rel={'noopener noreferrer'} >
                    <div className='card-image'>
                      <div className='icon-play'>
                        <FaYoutube size={40} />
                      </div>
                      <img src={item?.snippet?.thumbnails?.maxres?.url} alt={item.snippet.title} width={640} height={480} />
                      <small className='count'> <RiPlayList2Fill size={16} /> {`${item?.contentDetails.itemCount} วิดีโอ`}</small>
                    </div>
                    <h3>{item.snippet.title}</h3>
                  </a>
                </li>
              ))}
          </ul>
        </div>
      </div>
    </SectionWrapper>
  );
};

export default SectionYoutube;
const SectionWrapper = styled.div`
    color: #000;
    max-width: 100%;
    overflow: hidden;
    .more {
      color:red  !important;
      svg {
            color:red  !important;
        }
        &:hover {
          opacity: 0.8;
        }
    }
    .icon-play {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
  svg {
    color: #fff;
    opacity: 0.6;
  }
}
    .block-title {
        border-bottom: 2px dotted red !important;
        h2 {
            background: red !important;
        }
    }
    h3 {
        padding-top: 10px;
        font-size: 1rem;
        font-weight: 500;
    }
        img {
            width: 100%;
            height: auto;
            object-fit: cover;
            border-radius: 10px;

        }
        .card-image {
            position: relative;
            padding-top: 10px;
            img {
              border-radius: 8px;
            }
 
        }
        
        .count{
            position: absolute;
            bottom: 10px;
            right: 10px;
            background: rgba(0, 0, 0, 0.5);
            color: #fff;
            padding: 5px;
            border-radius: 10px;
            min-width: 50px;
            font-weight: 300;
            svg {
                margin-bottom: 2px;
            }
            }
    .grid-block{
        display: grid;
        grid-template-columns: 800px 1fr;
        grid-gap: 20px;
        grid-template-areas: "block-1 block-2";
        @media(max-width: 1440px){
          grid-template-columns: 2.5fr 1fr;

        }
        @media(max-width: 1024px){
          grid-template-columns: 1.5fr 1fr;

        }
         @media(max-width:767px){
            grid-template-columns:1fr;
            grid-template-areas: "block-1" "block-2";
        } 
                   }
    .block-1 {
        grid-area: block-1;
        a {

            position: relative;
        }
        .title {
            position: absolute;
            bottom: 10px;
            left: 10px;
            background: rgba(0, 0, 0, 0.5);
            color: #fff;
            padding: 5px;
            border-radius: 10px;
            min-width: 50px;
            font-weight: 300;
            svg {
                margin-bottom: 2px;
            }
            }
    }
    .block-2 {
        grid-area: block-2;
        .playlist-custom-scroll.--vertical{
height: 470px;
li {
  margin-bottom: 8px;
}
@media(max-width: 1024px){
  height: 340px;


}
@media(max-width: 900px){
  height: 260px;
  padding: 0;

  .card-image{
    padding-top: 8px;
  
  }
}
        }
        li {
            list-style-type: none;
        }
        .grid-item > a {
            display: grid;
            grid-template-columns: 1fr 1fr;
            grid-gap: 20px;
        }
      
  
    
    }
`;
